<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="4">
        <base-material-card class="v-card-profile" :avatar="image">
          <v-card-text v-if="loading" class="text-center">
            <p class="font-weight-light grey--text">{{ getRole(user) }}</p>
            <h6 class="display-1 mb-1 grey--text">Username: {{ user.username }}</h6>
            <h4
              class="display-2 font-weight-light mb-3 black--text"
            >{{ `${user.name} ${user.lastName} ` }}</h4>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col v-show="!isAdmin" cols="12" md="8">
        <v-card>
          <v-tabs v-model="tab" background-color="info" fixed-tabs dark>
            <v-tab v-for="item in items" :key="item.tab">
              <v-icon class="mr-3">{{ item.icon }}</v-icon>
              {{ item.tab }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-list-item-group>
                <v-list-item v-for="exam in exams" :key="exam.id" class="item-list">
                  <v-row class="item" @click="pushToExam(exam)">
                    {{ exam.subjectName }}
                    <v-spacer />
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <div>
                      <span class="font-weight-bold">Boshlanish vaqti -</span>
                      {{ exam.startTime | moment("LLL") }}
                      <br />
                      <span class="font-weight-bold">Tugash vaqti -</span>
                      {{ exam.finishTime | moment("LLL") }}
                    </div>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-tab-item>
            <v-tab-item>
              <v-list-item-group>
                <v-list-item v-for="result in results" :key="result.id" class="item-list">
                  <v-row
                    class="item"
                    @click="
                      $router.push(`/result-history/${result.id}`)
                    "
                  >
                    {{ result.examName }}
                    <v-spacer />
                    {{ result.score }}%
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import resultService from "../../../service/Result.service";
import ExamService from "../../../service/Exam.service";
export default {
  data() {
    return {
      tab: null,
      loading: false,
      items: [
        {
          tab: "Imtixonlar",
          content: "Tab 1 Content",
          icon: "mdi-book-open-outline",
        },
        {
          tab: "Javoblar",
          content: "Tab 2 Content",
          icon: "mdi-clipboard-outline",
        },
      ],
      image: require("@/assets/profile.png"),
      jwt: "",
      exams: [],
      results: [],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.user.roles[0].name !== "ROLE_USER";
    },
  },
  mounted() {
    this.user = this.$store.getters.user;
    setTimeout(() => {
      this.loading = true;
    }, 400);
  },
  created() {
    this.initial();
  },
  methods: {
    pushToExam(item) {
      if (
        new Date(item.startTime) - new Date() < 0 &&
        new Date(item.finishTime) - new Date() > 0
      )
        confirm(
          `Siz ${item.name} fandan topshirishni xohlaysizmi?`,
        ) && this.$router.push(`/exam-page/${item.id}`);
    },
    initial() {
      this.jwt = this.$store.getters.jwt;
      ExamService.getByCurrentUser(this.jwt).then(res => {
        this.exams = res.data;
      });
      resultService.getByCurrentUser(this.jwt).then(res => {
        this.results = res.data;
      });
    },
    getRole(user) {
      if (user !== undefined || user !== null) {
        const role = user.roles[0].name;
        if (role === "ROLE_MA") {
          return "ASOSIY ADMIN";
        }
        if (role === "ROLE_ADMIN") {
          return "ADMIN";
        }
        return "FOYDALANUVCHI";
      }
    },
  },
};
</script>
<style>
.item-list {
  padding: 10px 15px;
}
.item {
  margin: 0 15px;
}
</style>
